// Phones and tablets sign in with Google on the whole page. Google's popup opens as a separate tab on iPhones, which
// signs the site in but then stays on "Choose an account". Google sends the page back to the site's root with
// ?code=…&state=…, which the API exchanges with that address (its GOOGLE_WEB_REDIRECT_URIS)
const STATE_KEY = 'google_signin_state';

export const googleRedirectUri = () => `${window.location.origin}/`;

// A touch screen: a mouse keeps the popup
export const signInOnWholePage = () => window.matchMedia('(pointer: coarse)').matches;

let pageState: string | null = null;

// The state sent to Google, one for the page, kept in this tab: only a code that comes back with it is used
export const googleState = () => {
  if (!pageState) {
    pageState = Array.from(window.crypto.getRandomValues(new Uint8Array(16)), (byte) =>
      byte.toString(16).padStart(2, '0'),
    ).join('');
    try {
      sessionStorage.setItem(STATE_KEY, pageState);
    } catch {
      // Storage off (e.g. some private modes): the code won't match when it comes back, and isn't used
    }
  }
  return pageState;
};

const GOOGLE_PARAMS = ['code', 'state', 'scope', 'authuser', 'prompt', 'hd', 'iss', 'error', 'error_description'];

// At start-up, before the router: when Google sent the page back with this tab's state, its parameters are taken off
// the address (so the language redirect neither carries nor drops them) and the code is returned to sign in with.
// Null otherwise, or when the sign-in was cancelled
export const takeGoogleCode = (): string | null => {
  const params = new URLSearchParams(window.location.search);
  let expected: string | null = null;
  try {
    expected = sessionStorage.getItem(STATE_KEY);
  } catch {
    expected = null;
  }
  if (!expected || params.get('state') !== expected) {
    return null;
  }
  try {
    sessionStorage.removeItem(STATE_KEY);
  } catch {
    // Nothing to clear
  }

  const code = params.get('code');
  GOOGLE_PARAMS.forEach((key) => params.delete(key));
  const query = params.toString();
  window.history.replaceState(
    window.history.state,
    '',
    `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`,
  );
  return code;
};
